module.exports = require("passport-jwt");